export const nameItems = [
  { label: "First Name", value: 100 },
  { label: "Last Name", value: 200 },
];

export const paidByItems = [
  { label: "Paid By: ALL", value: 'all' },
  { label: "Paid By: Fixed Salary", value: 100 },
  { label: "Paid By: Hours", value: 200 },
];
export const viewItems = [
  { label: "View: ALL", value: 100 },
  { label: "View: Paid", value: 200 },
  { label: "View: Inactive", value: 300 },
];

export const rowsPerPageItems = [
  { label: "10 per page", value: 10 },
  { label: "25 per page", value: 25 },
  { label: "50 per page", value: 50 },
  { label: "100 per page", value: 100 },
];

export const ShowWithAlphabetItems = [
  { label: "Starts with: ALL", value: "all" },
  { label: "Starts with: A", value: "A" },
  { label: "Starts with: B", value: "B" },
  { label: "Starts with: C", value: "C" },
  { label: "Starts with: D", value: "D" },
  { label: "Starts with: E", value: "E" },
  { label: "Starts with: F", value: "F" },
  { label: "Starts with: G", value: "G" },
  { label: "Starts with: H", value: "H" },
  { label: "Starts with: I", value: "I" },
  { label: "Starts with: J", value: "J" },
  { label: "Starts with: K", value: "K" },
  { label: "Starts with: L", value: "L" },
  { label: "Starts with: M", value: "M" },
  { label: "Starts with: N", value: "N" },
  { label: "Starts with: O", value: "O" },
  { label: "Starts with: P", value: "P" },
  { label: "Starts with: Q", value: "Q" },
  { label: "Starts with: R", value: "R" },
  { label: "Starts with: S", value: "S" },
  { label: "Starts with: T", value: "T" },
  { label: "Starts with: U", value: "U" },
  { label: "Starts with: V", value: "V" },
  { label: "Starts with: W", value: "W" },
  { label: "Starts with: X", value: "X" },
  { label: "Starts with: Y", value: "Y" },
  { label: "Starts with: Z", value: "Z" }
];
